import { post } from '../axios'

export const eventTracking = params => post('/openapi/side/v1/event-tracking', params)
